import { makeAutoObservable } from 'mobx';
import { ICredentialsStore } from '../../integration-store';
import { IIntersoftCredentialsModel } from '../../../../../../models/IntegrationsTypes';

class IntersoftCredentialsStore implements ICredentialsStore {
    private _changes: IIntersoftCredentialsModel = {} as IIntersoftCredentialsModel;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }
    public get customerNumber() { return this._changes.customer_number; };
    public get emailAddress() { return this._changes.email_address; };
    public get internalName() { return this._changes.internal_name; };
    public get apiKey() { return this._changes.api_key; };
    public get addressLine1() { return this._changes.address_line1; };
    public get town() { return this._changes.town; };
    public get postcode() { return this._changes.postcode; };
    public get countryCode() { return this._changes.country_code; };
    public get contactName() { return this._changes.contact_name; };
    public get contactPhone() { return this._changes.contact_phone; };

    setInternalName(value: string) {
        this._changes.internal_name = value;
    };
    
    setApiKey(value: string) {
        this._changes.api_key = value;
    };

    setEmailAddress(value: string) {
        this._changes.email_address = value;
    };

    setCustomerNumber(value: string) {
        this._changes.customer_number = value;
    };

    setAddressLine1(value: string) {
        this._changes.address_line1 = value;
    };

    setTown(value: string) {
        this._changes.town = value;
    };

    setPostcode(value: string) {
        this._changes.postcode = value;
    };

    setCountryCode(value: string) {
        this._changes.country_code = value?.toUpperCase();
    };

    setContactName(value: string) {
        this._changes.contact_name = value;
    };

    setContactPhone(value: string) {
        this._changes.contact_phone = value;
    };

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }
}

export default IntersoftCredentialsStore;
